import { always } from 'ramda'

// Action types
export const DOWNLOAD_ANDROID_APP = 'mobileApps/DOWNLOAD_ANDROID_APP'
export const DOWNLOAD_IOS_APP = 'mobileApps/DOWNLOAD_IOS_APP'

// downloadAndroidApp :: () -> Action
export const downloadAndroidApp = always({ type: DOWNLOAD_ANDROID_APP })

// downloadIOSApp :: () -> Action
export const downloadIOSApp = always({ type: DOWNLOAD_IOS_APP })
